<div class="max-h-full flex flex-col gap-4 px-4 pt-4">
  @if (showLoader) {
    <app-loader />
  }
  <h3 class="m-0">{{pickDayText}}</h3>
  <div class="flex gap-2">
    <mot-date-picker [formControl]="dateFormControl" [label]="dayText" [minDate]="minDate" [maxDate]="maxDate"
      [displayErrors]="false" class="w-full" style="width: 50%"/>
    <mot-time-picker [formControl]="timeControl" [label]="timeText" icon="clock"
      iconClass="text-2xl" class="w-full" style="width: 50%"/>
    </div>
    <app-search-station-detailed-result-routes-calendar-list [stopTimes]="stopTimes" [lines]="routesInStop.length > 0 ? routesInStop : stop.routesInStop"
      [routeSpecialMessages]="routeSpecialMessages" [stopCode]="stop.stopcode"
      class="flex-1 overflow-y-auto use-scrollbar px-1" (pickLineEvent)="pickLine($event)" [isToday]="isToday"
      [selectedDate]="getSelectedDate()" [selectedTime]="timeControl.value" />
    </div>
